<template>    
    <v-card class="px-0" v-if="item">
        
        
        <v-img position="center left" :src="imagePreview" width="100%" aspect-ratio="5.25" v-on:click="openGallery(currentIndexImage)">
            <v-btn v-on:click.stop="backToList" color="grey darken-4">
                <v-icon 
                    large
                    color="white"
                    >arrow_back</v-icon>
            </v-btn>
        </v-img>                        
        
        <v-card-text class="px-0">
            <v-container fluid fill-height >
                <v-layout row wrap fill-height justify-start>                                        
                    <v-flex xs12>
                        <h2 class="display-2">{{ item.name }}</h2>
                    </v-flex>
                    <v-flex xs12 v-if="item.specification">
                        <p class="title">{{item.specification.name}}</p>
                    </v-flex>
                    <v-flex xs12 v-else>
                        <p class="title">&nbsp;</p>
                    </v-flex>
                    <v-flex xs12>
                        <v-rating
                            v-model="rating"
                            background-color="light-grey"
                            color="yellow accent-4"
                            dense
                            half-increments
                            empty-icon="$vuetify.icons.ratingFull"
                            hover
                            readonly
                            size="18"
                        ></v-rating>
                    </v-flex>
                    <v-flex xs12 class="pt-5">
                        <v-container fluid >
                            <v-layout col class="align-start justify-content-start">                            
                                <v-flex d-flex v-if="recipesteps.length">
                                    <v-layout row wrap>
                                        <v-flex xs12 >
                                            <h2 class="title">Zubereitung</h2>
                                        </v-flex>
                                        <v-flex xs12 class="pt-5">
                                            <v-data-table
                                                :headers="headers"
                                                :items="recipesteps"
                                                hide-actions
                                                class="elevation-1"
                                             >
                                                <template slot="items" slot-scope="props">                              
                                                  <td class="text-xs-right">{{ props.item.unitvalue }}</td>                             
                                                  <td class="text-xs-right">{{ props.item.unit.name }}</td>
                                                  <td class="text-xs-right">{{ props.item.ingredient.name }}</td>
                                                  <td class="text-xs-right"><span v-for="treatment in props.item.treatments">{{ treatment.name }},</span></td>
                                                  <td class="text-xs-right"><span v-for="preparation in props.item.preparations">{{ preparation.text }},</span></td>                              
                                                </template>

                                            </v-data-table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex d-flex offset-xs1 v-if="item.tags.length">
                                    <v-layout row wrap>
                                        <v-flex xs12 class="pb-5">
                                            <h2 class="title">Tags</h2>
                                        </v-flex>
                                        <v-flex xs6 v-for="cat in Object.keys(displaycategories)">
                                            <span class="subheading">{{cat}}</span> <br>
                                            <ul>
                                                <li v-for="tag in displaycategories[cat]">
                                                    <span>{{ tag }}</span>
                                                </li>
                                            </ul>
                                        </v-flex>
                                    </v-layout>                                
                                </v-flex>                                
                            </v-layout>
                        </v-container>
                    </v-flex> 
                    <v-flex xs12 class="pt-5">
                        <v-container fluid>
                            <v-layout col class="align-start justify-content-start">
                                <v-flex d-flex>
                                    <v-layout row wrap>
                                        <v-flex xs12 class="pb-5">
                                            <h2 class="title">Zutaten Liste</h2>
                                        </v-flex>
                                        <v-flex xs12>
                                             <ul>
                                                <li v-for = "calc in calculated">
                                                    {{ calc}}
                                                </li>
                                            </ul>
                                        </v-flex>
                                    </v-layout>                                                                       
                                </v-flex>
                            </v-layout>  
                        </v-container>
                    </v-flex>                   
                </v-layout>
            </v-container>
        </v-card-text>
        <vue-image-lightbox-carousel
                            ref="lightbox"
                            :show="showLightbox"
                            @close="showLightbox = false"
                            :images="images"
                            @change="changeHighlight"
                            :showCaption="false"
                        >
        </vue-image-lightbox-carousel>
        <formstopperdialog
            :show="loading">
            
        </formstopperdialog>
    </v-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    import formstopperdialog from '../components/forms/FormStopperDialog.vue'
    import { forEach, findIndex, orderBy, cloneDeep } from 'lodash'
    import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
    export default {   
    
    props: [
        
        'vuexnamespace'
    ],
    components: {
        formstopperdialog,
        VueImageLightboxCarousel
    },
    data() {
        return {  
            rating:0,
            currentIndexImage: 0,
            images: [],
            showLightbox: false, 
            id: this.$route.params.id, 
            loading:false,
            headers:[
                {
                text: 'Menge',            
                sortable: false,
                value: 'unitvalue'
              },
              {
                text: 'Einheit',            
                sortable: false,
                value: 'unit.name'
              },
              {
                text: 'Zutat',            
                sortable: false,
                value: 'ingredient.name'
              },
              {
                text: 'Verarbeitung',            
                sortable: false,
                value: 'treatments'
              },
              {
                text: 'Zubereitung',            
                sortable: false,
                value: 'preparations'
              },
                          
            ]
        }
    },
    watch:{
        $route: function(to,from) {
            if(typeof this.$route.params.id != "undefined") {
                this.id = this.$route.params.id
                this.init()                                                
            } else {
                this.id=undefined                
            }            
        }
    },
    computed: {
        ...mapGetters({
            paths:'shared/paths',
            tagcategories:'tagcategories/tagcategories'
        }),
        item() {return this.$store.getters['entities/getshowresult']},            
        recipesteps(){return this.$store.getters['recipesteps/forrecipe']},
        imagePreview () {
            let index = findIndex(this.images, { highlight: 1 })
            
            if (index > -1) {
                return this.images[index].path
            } else {
                return this.images.length ? this.images[0].path : ''
            }
        },
        displaycategories(){
            var rv={}
            for (let i=0;i< this.item.tags.length;i++) {
                for(let j=0;j<this.item.tags[i].tagcategories.length;j++) {                   
                    let key = this.item.tags[i].tagcategories[j].name
                    if(!(key in rv)) {
                        rv[key]=[]
                    }
                    rv[key].push(this.item.tags[i].name)
                }
            }
            return rv
        },
        calculated(){
            return this.reduce_recursive(this.flatten_recursive(this.item.children_recursive))
            
        }                
    },
    methods: {        
        
        flatten_recursive(array) {
            
            var result = [];
            
            array.forEach((a) => {
                let vObj = {
                    id:a.id,
                    name:a.name,
                    unit: 'kg',
                    unitvalue:a.pivot.unitvalue,
                    papa:a.pivot.entity_id,
                    children:[]
                }
                if(Array.isArray(a.children_recursive)) {
                    if(a.children_recursive.length) {
                        vObj.children=this.flatten_recursive(a.children_recursive)                                              
                    }                    
                    result.push(vObj)                                                                                
                }               
            })
            return result;
        },   
        reduce_recursive(obj) {                        
            return obj.reduce((acc,val,index,array)=> {
                const inner = Array.isArray(val) ? val : [val]
                    inner.forEach((v)=>{
                        let str = v.name + ' (' + v.unitvalue + ' ' + v.unit + ')'
                        if(v.children.length) {
                            acc.push('Rezept: ' + str + ' -> ')
                            acc.push(this.reduce_recursive(v.children))
                        } else {
                            acc.push('Zutat: ' + str)
                        }
                })                                      
                
                return acc
            
            },[])
        },
        backToList(){
            this.showLightbox=false;
            this.$router.push(
                {
                    name:'entities'
                }
            )
        },
        changeHighlight (currentIndex) {
            this.currentIndexImage = currentIndex
            this.images.map((item, index) => {
                if (currentIndex === index) {
                    item.highlight = 1
                } else {
                    item.highlight = 0
                }
                return item
            })
        },
        
        openGallery(index) {
            this.showLightbox = true
            this.$refs.lightbox.showImage(index)
        },
        onOpenedLightBox(value) {
            if (value) {
                this.showLightbox = true
            } else {
                this.showLightbox = false
            }
        },
        async init() {
            this.loading=true
            await this.$store.dispatch('tagcategories/getAll')
            await this.$store.dispatch('recipesteps/getAll')
            this.$store.dispatch('entities/getAll')
                .then(response=> {   
                    this.$store.commit('entities/ENTITY_SET_SHOWRESULT',this.$route.params.id)  
                    this.$store.commit('recipesteps/RECIPESTEP_SET_FORRECIPE',this.$route.params.id)
                    this.images=this.item.logos.map(a=>{
                            let ret={}
                            ret.path= this.paths.storagepath + a.serverpath
                            ret.name=a.name
                            ret.highlight=0
                            return ret
                        })                                           
                    return
                })
                .catch(error=> {                                        
                    this.setMessage(error.response.status,error.response.data.message)  
                    return
                })
            this.loading=false
        }
        
    },
    created() {
        if(typeof this.$route.params.id != 'undefined') {            
            this.id = this.$route.params.id
            this.init()            
        } else {
            this.id= undefined                          
        }   
        
    }
    
    
}
</script>